import styled, { css } from 'styled-components';
import Select from 'react-select';
import { ReactComponent as Sorted } from '../../../../../assets/img/sort-arrows.svg';
import { themedSelectMenuCss } from '../../../../../theme/selectStyles';

export const StyledNameContainer = styled.div`
  padding-left: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledManipulator = styled.div`
  margin-bottom: 27px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  > h3 {
    font-family: 'Archivo', sans-serif;
    font-size: 34px;
    line-height: 41px;
    font-weight: 900;
    letter-spacing: 0.005em;
    color: ${({ theme }) => theme.text};
  }
`;
export const StyledSelectContainer = styled.div`
  width: 100%;
  margin: 5px;
  > input {
    border: none;
  }
  @media screen and (max-width: 1204px) {
    flex: none;
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    max-width: inherit;
  }
`;

export const StyledSelect = styled(Select)`
  .react-select__control {
    background: ${({ theme }) => theme.card};
    border: 1px solid ${({ theme }) => theme.border};
    color: ${({ theme }) => theme.text};
    box-shadow: none;
  }
  .react-select__single-value,
  .react-select__input-container {
    color: ${({ theme }) => theme.text};
  }
  .react-select__placeholder {
    font-family: 'Archivo', sans-serif;
    font-size: 14.222px;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.textFaint};
  }
  ${themedSelectMenuCss}
`;

export const StyledTableContainer = styled.section`
  width: 100%;
  overflow: auto;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  padding: 4px 12px 8px;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-style: hidden;
  @media screen and (max-width: 768px) {
    [type='Age'],
    [type='Actions'],
    [type='Zone'],
    [type='League'],
    [type='Team'],
    [type='Status'] {
      display: none;
    }
    th[type='Actions'] {
      border-top-right-radius: 9px;
    }
  }
  @media screen and (max-width: 991px) {
    [type='League'],
    [type='Team'] {
      display: none;
    }
  }
`;

export const StyledThead = styled.thead`
  ${({ display }) => {
    if (display === 'none')
      return css`
        display: none;
      `;
  }}
`;

export const StyledTbody = styled.tbody`
  /* border-top: 12px solid #e5e5e5; */
  &::before {
    content: '';
    display: block;
    height: 0px;
  }
`;

export const StyledTrTh = styled.tr``;

export const StyledTh = styled.th`
  text-align: left;
  padding: 9px 0 9px 15px;
  background: transparent;
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 21px;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.textFaint};
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  @media screen and (max-width: 425px) {
    font-size: 11px;
    padding: 9px 0 9px 5px;
  }
  &:first-of-type {
    border-top-left-radius: 9px;
    border-bottom-left-radius: 0px;
  }
  &:last-of-type {
    border-top-right-radius: 9px;
    border-bottom-right-radius: 0px;
  }
  ${({ display, titleNumberName, type }) => {
    if (titleNumberName)
      return css`
        display: none;
      `;
    if (display === 'none')
      return css`
        display: none;
      `;
    if (type === 'Number') {
      return css`
        min-width: 50px;
      `;
    }
    if (type === 'Name') {
      return css`
        min-width: 105px;
      `;
    }
    if (type === 'For sale' || type === 'For loan' || type === 'Scouting') {
      return css`
        display: none;
        font-size: 0;
        span {
          display: none;
        }
      `;
    }
    if (type === 'Actions') {
      return css`
        span {
          display: none;
        }
      `;
    }
  }}
`;
export const StyledSorted = styled(Sorted)`
  margin-bottom: -5px;
  margin-left: 5px;
  width: 10px;
  height: 20px;
  fill: ${({ theme }) => theme.textFaint};
  ${({ type }) => {
    if (type === 'fromMinToMax') {
      return css`
        path:first-of-type {
          display: none;
        }
      `;
    }
    if (type === 'fromMaxToMin') {
      return css`
        path:last-of-type {
          display: none;
        }
      `;
    }
  }}
`;

export const StyledTrTd = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  background: transparent;
  &:last-of-type {
    border-bottom: 0;
    td {
      &:first-of-type {
        border-bottom-left-radius: 5px;
      }
      &:last-of-type {
        border-bottom-right-radius: 5px;
      }
    }
  }
  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme.hover};
  }
  &.clicked {
    cursor: pointer;
    background: ${({ theme }) =>
      theme.isDark ? 'rgba(14, 74, 251, 0.24)' : 'rgba(14, 74, 251, 0.12)'};
  }
  ${({ clicked, theme }) => css`
    &.row-number-${clicked} {
      background: ${theme.isDark
        ? 'rgba(14, 74, 251, 0.24)'
        : 'rgba(14, 74, 251, 0.12)'};
      td {
        color: ${theme.text};
      }
      .scouting {
        color: #ff4d09 !important;
      }
    }
  `}
`;

export const StyledTd = styled.td`
  height: 40px;
  text-align: left;
  padding-left: 15px;
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.text};
  @media screen and (max-width: 425px) {
    font-size: 12px;
    padding-left: 5px;
  }
  ${({ titleCell, type }) => {
    if (titleCell)
      return css`
        text-align: left;
      `;
    if (type === 'PTS') {
      return css`
        span {
          background: rgba(14, 74, 251, 0.1);
          border: 1px solid rgba(187, 199, 234, 0.45);
          border-radius: 5px;
          padding: 0 11px;
        }
      `;
    }
    if (type === 'Name') {
      return css`
        @media only screen and (max-width: 768px) {
          padding-left: 5px;
          width: 120px;
        }
      `;
    }
    if (type === 'NO') {
      return css`
        opacity: 0.5;
      `;
    }
    if (type === 'For sale' || type === 'For loan' || type === 'Scouting') {
      return css`
        display: none;
      `;
    }
  }}
`;

export const StyledPagination = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 30px;
`;

export const ArrowRight = styled.i`
  border: solid ${({ theme }) => theme.text};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
`;
export const ArrowLeft = styled.i`
  border: solid ${({ theme }) => theme.text};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
  transform: rotate(-225deg);
`;

export const StyledPaginationButton = styled.button`
  border: 0;
  box-shadow: none;
  background-color: transparent;
  color: ${({ theme }) => theme.text};
  border-radius: 3px;
  align-self: center;
  display: flex;
  flex-direction: row;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;
export const StyledPageNumber = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 20px;
`;

export const StyledPageLabel = styled.span`
  font-size: 13px;
  margin: 0 10px;
  color: ${({ theme }) => theme.text};
`;

export const StyledUnderlineTeam = styled.span`
  text-decoration: underline;
`;

export const StyledTeamCell = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;
